<div class="bgHelpercolor flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-full">
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
    <circle class="stroke-gray-icon" cx="9" cy="21" r="1" stroke-width="2" />
    <circle class="stroke-gray-icon" cx="20" cy="21" r="1" stroke-width="2" />
    <path
      class="stroke-gray-icon"
      d="M1 1h4l2.68 13.39a2 2 0 001.97 1.61h9.72a2 2 0 001.97-1.61L23 6H6"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</div>
